fx.ns("desktop.common.photoimport", class AlbumsPhotos extends fx.components.ScreenPopup {
    
	constructor(data)
	{
        super(data);

		this.showClose = true;
    }

	get currentAlbum()
	{
		return this._currentAlbum;
	}

	set currentAlbum(val)
	{
        if (this._currentAlbum)
            this._currentAlbum.selected = false;

		this._currentAlbum = val;

        if (this._currentAlbum)
            this._currentAlbum.selected = true;
	}

    get selectedPhotos()
    {
        let photos = [];
        for ( let j = 0; j < this.data.albums.length; j++)
        {
            let album = this.data.albums.getItemAt(j);
            photos = photos.concat(album.selectedPhotos );
        }
        return photos;
    }


    create()
	{
		super.create();
		
		// Header
		let boxHeader = new fx.components.Box('header');
		this.addChild(boxHeader, {top: 20, width: '100%', height: 48});

		let vosAlbumsLogo = new fx.components.Image(fx.assets.vosAlbumsLogo);
		let vosAlbumsLogoText = new fx.components.Text(fx.text('Vos Creations'));

		let logoWrapper = new fx.components.Box('icon-wrapper');
		logoWrapper.addChild(vosAlbumsLogo, {width:48, height:48});
		logoWrapper.addChild(vosAlbumsLogoText, {top:9, left:63});
		boxHeader.addChild(logoWrapper, {width:220, height:48, left : 20});
		
		// Selection
		let boxSelection = new fx.components.Box('selection');
		this.addChild(boxSelection, {top: 70, left : 0, width: '100%', height: 40});

		let selectionAction = new fx.components.HBox('selection-action')
		this.selectAll = new fx.components.Text({text: fx.text('Tout sélectionner'), className: 'selectAll'});
		this.selectNone = new fx.components.Text({text: fx.text('Tout déselectionner'), className: 'selectNone'});
		selectionAction.addChild(this.selectAll);
		selectionAction.addChild(this.selectNone);
		boxSelection.addChild(selectionAction, {right : 10, width: 300, height: 48});

		// Container
		let boxContainer = new fx.components.Box('data');
		this.addChild(boxContainer, {top: 110, width: '100%', height: '100%'});

		// Albums
		let albums = new fx.components.Box('albums');
		boxContainer.addChild(albums, {width: '205px', height: '100%'});

		this.albumsContainer = new fx.components.Box('albums-container');
		albums.addChild(this.albumsContainer);
		
		// Photos
		let photos = new fx.components.Box('photos');
		boxContainer.addChild(photos, {left: 210, width : "fill", height : "100%"});

		this.photosContainer = new fx.components.Box('photos-container');
		photos.addChild(this.photosContainer, {width : "100%"});
		this.grid = new fx.components.VerticalGridDynamic( {renderers: {PhotoAlbum: shared.renderers.AlbumPhotoRenderer}, hasOnlyUnique: false } );
		this.grid.filter = new filters.SortPhotosChronological();
		this.grid.filter.photosused = true;
		this.photosContainer.addChild(this.grid, {height:"100%", width:"100%", left: 0});

        // Buttons
        let buttons = new fx.components.HBox('button-container');
        this.addChild(buttons, {bottom: 0, width: '100%', height: 80});

        this.validateButton = new fx.components.Button({label: fx.text("Ajouter"), type : "filled", className: 'button'});
		buttons.addChild(this.validateButton, {width : 300});        
	}

	onReady()
	{
		super.onReady();
		
        this.on("click", this.onAlbumClick, this.albumsContainer);

		this.on("click",this.onSelectAll, this.selectAll);
		this.on("click",this.onSelectNone, this.selectNone);
        this.on("click",this.onCopyPhotos, this.validateButton);
		
		if (this.data.albums.length == 0)
        {
            this.loading(true, fx.text("Chargement"));
			this.data.loadAlbums();
        }
        else
        {
            this._addAlbums();
            this.photosContainer.loading(true, fx.text("Chargement"));

            this.currentAlbum = this.data.albums.getItemAt(0);
            this.data.loadAlbumPhotos(this.currentAlbum.id);
        }

		this._updateValidateButton();
	}

    onDataEvent(event)
	{
		super.onDataEvent(event);
		
		switch(event.type)
		{
			case "albums-error" :
            case "album-photos-error" :
            case "album-photos-copy-error" :
				this.loading(false);
                break;

            case "albums-loaded" :
                this._addAlbums();
                this.loading(false);
                this.photosContainer.loading(true, fx.text("Chargement"));

                this.currentAlbum = this.data.albums.getItemAt(0);
                this.data.loadAlbumPhotos(this.currentAlbum.id);
                break;

            case "album-photos-loaded" :
                this.photosContainer.loading(false);
                this.grid.data = this.currentAlbum.photos;
                break;

            case "album-photos-copied" : 
                this.loading(false);
                this.unSelectAllPhotos();
                this.close();
            break;
		}
	}

    onChildUpdated(action)
    {
        if (action.type == "update" && action.impacts("selected"))
            this._updateValidateButton();
    }

	// ------------- HANDLERS -------------- //	

    onAlbumClick(e)
    {
        let albumUI = fx.dom.parent(e.target, ".AlbumRenderer");
        if (albumUI)
        {
            let albumid = albumUI.getAttribute("data-id")
            this.currentAlbum = this.data.albums.find({id :albumid });
            this.data.loadAlbumPhotos( albumid );
            this.photosContainer.loading(true, fx.text("Chargement"));
        }
            
    }

	onCopyPhotos()
	{
		this.loading(true, fx.text("Récupération des photos") + "...");
        this.data.copyAlbumPhotos(this.selectedPhotos);
	}

	onSelectAll()
	{
        for ( let i = 0; i < this.currentAlbum.photos.length; i++)
            this.currentAlbum.photos.getItemAt(i).selected = true;
	}
	
	onSelectNone()
	{
		for ( let i = 0; i < this.currentAlbum.photos.length; i++)
            this.currentAlbum.photos.getItemAt(i).selected = false;
	}

    unSelectAllPhotos()
    {
        for ( let j = 0; j < this.data.albums.length; j++)
        {
            let album = this.data.albums.getItemAt(j);
            for ( let i = 0; i < album.photos.length; i++)
                album.photos.getItemAt(i).selected = false;
        }
    }

    _updateValidateButton()
	{
		if (this.validateButton == null) return;
		
		let number = this.selectedPhotos.length;		
		
		this.validateButton.enabled = (number > 0);
        
		this.validateButton.label = fx.text("Ajouter $ photo$", [number, (number > 1 ? "s" : "")]);
	}

    _addAlbums()
    {
        for ( let i = 0; i < this.data.albums.length; i++)
            this.albumsContainer.addChild(new shared.renderers.AlbumRenderer(this.data.albums.getItemAt(i)), { width : 190, height : 180});
    }

	destroy()
	{
		super.destroy();
		this.unSelectAllPhotos();
	}

});